import { IdentifiableDto } from "./identifiable.dto";
import { HiringZipDto } from "./lookup.dto";

export class MatchedLeadsProductHiringZipDto extends IdentifiableDto {
    zip: HiringZipDto;
    radius: number;
}